import { Record } from 'immutable';
import { handleAction } from 'redux-actions';
import breakpoints from 'rp-mq-breakpoints';
import { switchBreakpoint } from '../actions/breakpoint';

export const ReducerRecord = Record({
  current: breakpoints.current(),
  previous: breakpoints.current(),
});

export default handleAction(switchBreakpoint, (state, { payload }) => (
  state
    .set('current', payload.breakpoint)
    .set('previous', payload.breakpointPrevious)
), new ReducerRecord());

